import { ReactNode } from 'react';

import styles from '@components/cards/Card.module.css';
import { isMobileWeb, isNativeApp } from '@utils/platformUtils';

type Props = {
  active?: boolean;
  background?: 'neutral50' | 'neutral100' | 'primary300' | 'primary100' | 'error300';
  border?: 'error300';
  boxShadow?: boolean;
  children: ReactNode;
  hover?: 'none' | 'purple' | 'normal';
  inactive?: boolean;
  padding?: 'small' | 'normal' | 'none' | 'large';
};

const BasicCard = ({
  active = false,
  background,
  border,
  boxShadow = true,
  children,
  hover = 'normal',
  inactive = false,
  padding = 'normal'
}: Props) => {
  const isMobile = isMobileWeb() || isNativeApp();
  return (
    <div
      className={`${styles.card} ${boxShadow ? '' : styles.noBoxShadow} ${
        padding === 'small'
          ? styles.cardSmallPadding
          : padding === 'large'
          ? styles.cardLargePadding
          : padding === 'none'
          ? styles.cardNoPadding
          : ''
      } ${styles[background ?? '']} ${
        isMobile ? '' : hover === 'normal' ? styles.cardHover : hover === 'purple' ? styles.cardPurpleHover : ''
      } ${inactive ? styles.cardInactive : ''} ${active ? styles.cardActive : ''} ${styles[`${border}Border` ?? '']}`}
    >
      {children}
    </div>
  );
};

export default BasicCard;
